import { Hero } from "../components/sections/Hero";
import { MarqueeStrip } from "../components/sections/MarqueeStrip";
import { Manifesto } from "../components/sections/Manifesto";
import { Services } from "../components/sections/Services";
import { Portfolio } from "../components/sections/Portfolio";
import { TrustBanner } from "../components/sections/TrustBanner";
import { Contact } from "../components/sections/Contact";
import { Reviews } from "../components/sections/Reviews";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <MarqueeStrip />
      <Manifesto />
      <Services />
      <Portfolio />
      <TrustBanner />
      <Contact />
      <Reviews />
    </main>
  );
}
